module.exports = __webpack_public_path__ + "static/media/user.83c235eb.svg";